<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号" clearable></el-input></el-form-item>
        <el-form-item label="买家信息"><el-input size="small" v-model="searchForm.user_keyword" placeholder="请输入昵称或手机号码" clearable></el-input></el-form-item>
       <el-form-item label="设备名称"><el-input size="small" v-model="searchForm.product_name" placeholder="请输入设备名称" clearable></el-input></el-form-item>
       

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
 

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit"  >查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport"  v-auth="'/order/order/operate/export'">导出</el-button></el-form-item>
        <el-form-item><el-button size="small" type="primary" @click="importOrder"  v-auth="'/order/order/operate/import'">导入</el-button></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款(' + order_count.payment + ')'" name="payment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
          <el-tab-pane label="已退款" name="refund"></el-tab-pane>
          <el-tab-pane label="取消订单" name="canceling"></el-tab-pane>
          <el-tab-pane label="已取消" name="cancel"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_no" label="订单信息" width="400" >
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="c_main hand" @click="handleCopy(scope.row.order_no, $event)">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>

              </div>
              <template v-else>
                  <div class="product-info" 
                   >
                  <div class="pic"><img v-img-url="scope.row.equip.cover?scope.row.equip.cover:''" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ scope.row.equip.name }}</span>
                    </div>
                    <div class="name gray3 product-name">
                      <span>已用时间：{{ scope.row.use_time?scope.row.use_time:0 }}</span>
                    </div>
               
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ scope.row.pay_price }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="minutes" label="购买时长">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div >{{ scope.row.minutes }}分钟</div>
            </template>

          </el-table-column>
          <el-table-column prop="minute" label="已用时长">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.use_time?scope.row.use_time:0  }}分钟</div>
            </template>

          </el-table-column>
          <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="yi_refund_price" label="实退款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.yi_refund_price }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.user?scope.row.user.nickName:'' }}</div>
              <div class="gray9">ID：({{ scope.row.user? scope.row.user.user_id:'' }})</div>
             </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.state_text }}
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="使用状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.is_use.text }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="is_refund" label="退款状态">
            <template slot-scope="scope">
              <span class="gray9" v-if="scope.row.is_refund == 0">未申请</span>
              <span class="gray9" v-if="scope.row.is_refund == 1">审核中</span>
              <span class="gray9" v-if="scope.row.is_refund == 2">通过</span>
              <span class="gray9" v-if="scope.row.is_refund == 3">未通过</span>
            </template>
          </el-table-column>
          <el-table-column prop="reject_val" label="不通过原因"></el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="d-b-c">
                  <el-button v-if="(supply_id>0&&supply_setting.order_detail>0||supply_id==0)" @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/detail'">订单详情</el-button>
              
                  <el-button  @click="delClick(scope.row)" type="text" size="small" v-auth="'/order/order/del'">删除</el-button>
         
                </div>
       
  
              <el-button v-if="scope.row.status.value == 10&&scope.row.is_refund == 1" @click="addClick(scope.row)" type="text" size="small" >去审核</el-button>
           
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

   

   

    <!-- 上传导入组件  -->
    <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

  
  </div>
</template>

<script>
import OrderApi from '@/api/order.js'
import Upload from '@/components/file/import'
import qs from 'qs'
import clip from '@/utils/clipboard'

export default {
  components:{
    Upload
  },
  data() {
    return {
      order_id: 0,
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        user_keyword:"",
        received_keyword:"",
        extract_keyword:"",
        store_keyword:"",
        product_name:"",
        export_type:'',
        order_no: '',
        style_id: '',
        create_time: '',
        order_source:"0",
        remark: '',
        agent_log_status: '',
        is_import: '',
      },

      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0
      },
      supply_id:0,
      supply:{},
      open_upload:false,
      // 导入类型
      import_type:'order',
      dialogBatchDelivery: false,
      is_admin_remark: false,
      remarkForm: {
        order_id: '',
        remark: '',
      },
      is_userid: false,
      useridForm: {
        order_id: '',
        user_id: '',
      },
      open_detail: false,
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    delClick(row){
      let self = this;
      let params = {
        order_id:row.order_id
      };
      self
        .$confirm('是否删除该订单，删除后，返佣佣金也会删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          OrderApi.delEquip(
            params,
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getData();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },
    openDetail(e){
      this.order_id = e.order_id;
      this.open_detail = true;
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.getEquipIndex(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              // order_source:item.order_source,
              // order_source_text:item.order_source_text,
              is_top_row: true,
              remark: item.remark
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;
          self.totalDataNumber = res.data.list.total;

          self.supply_id = res.data.supply_id;
          if(self.supply_id>0){
            self.supply_setting = res.data.supply.kmd_grade.setting;
          }

          console.log(self)
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/equip/Detail',
        query: {
          order_id: params
        }
      });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(this.searchForm);
    },
    // 商品导入
    importOrder:function(row){
      this.open_upload = true
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
        if (f == 'upload') {
            this.open_upload = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
        }else if (f == 'detail') {
            this.open_detail = e.openDialog;
        }
    },
    // 显示批量发货说明
    showBatchDelivery() {
      this.dialogBatchDelivery = true;
    },
    /*跳转物流公司*/
    gotoExpress() {
      let self = this;
      self.$router.push('/setting/express/index');
    },

    /*选择图片之前*/
    onBeforeUploadImage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isEXCEL = fileType === 'xlsx';
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isEXCEL) {
        this.$message.error('上传文件只能是excel格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isEXCEL && isLt10M;
    },

    /*上传图片*/
    uploadImage(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: '正在处理,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let formData = new FormData();
      formData.append('iFile', param.file);
      OrderApi.batchDelivery(formData)
        .then(response => {
          loading.close();
          self.dialogBatchDelivery = false;
          self.$message({
            message: response.msg,
            type: 'warning'
          });
        })
        .catch(response => {
          loading.close();
          self.$message({
            message: '本次处理失败',
            type: 'warning'
          });
          param.onError();
        });
    },

    handleCopy(text, event) {
      clip(text, event)
    },

 
  }
};
</script>
<style lang="scss" scoped>
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/equip/index.vue